import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { TownsReducerActionType } from '../reducers/townsReducer';

// Types des actions d'automation
export const LIST_TOWNS = 'list_towns';

export const listTowns =
  () =>
  (dispatch: Dispatch<TownsReducerActionType>, getState: () => RootState) => {
    const {
      client: { get },
    } = getState();

    get('/places/towns', ({ data }: any): void => {
      data &&
        dispatch({
          type: LIST_TOWNS,
          payload: Object.entries(data).map(([key, value]) => ({
            id: key,
            name: value,
          })),
        });
    });
  };
